import React from 'react';

const BookingPageContext = React.createContext({
  booking: null,
  reloadBooking: () => {},
  setTags: () => {},
  addBookingNote: () => {},
  updateTripAssignment: () => {},
});

export default BookingPageContext;
